import styled from 'styled-components';

interface TextInputProps {
  tiny?: boolean;
}

export default styled.input<TextInputProps>`
  border: 1px solid ${(props) => props.theme.colors.greyDark};
  width: ${(props) => (props.tiny ? '39px' : '68px')};
  height: ${(props) => (props.tiny ? '16px' : 'auto')};
  font-size: 12px;
  text-align: center;
  outline: 0;

  &:focused {
    border: 1px solid ${(props) => props.theme.colors.secondary};
  }
`;
